// extracted by mini-css-extract-plugin
export var li = "_tm-2";
export var ol = "_tm-1";
export var ul = "_tm-0";